.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2xs);

  padding: var(--space-3xs) var(--space-xs);

  font-size: var(--size-100);
  font-weight: var(--weight-medium);
  letter-spacing: 0.01em;
  white-space: nowrap;

  color: var(--text);
  background-color: var(--tint);

  border-radius: var(--radius-pill);
}

.dot {
  width: 0.5rem;
  height: 0.5rem;

  background-color: var(--tone);

  border-radius: var(--radius-pill);
}

.missing {
  --tone: var(--band-missing);
  --tint: var(--band-tint-missing);
}

.partial {
  --tone: var(--band-partial);
  --tint: var(--band-tint-partial);
}

.solid {
  --tone: var(--band-solid);
  --tint: var(--band-tint-solid);
}

.excellent {
  --tone: var(--band-excellent);
  --tint: var(--band-tint-excellent);
}

.unassessed {
  --tone: var(--band-unassessed);
  --tint: var(--band-tint-unassessed);
}
